export default __webpack_public_path__ + "static/InterDisplay-Regular-c451e4531db3370141193acba0a4103b.woff";